import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, Title} from "@khanacademy/wonder-blocks-typography";
import {doNotTranslateYet} from "@repo/i18n";

import type {Standard} from "./types.ts";

type Props = {
    subTreeToShow: Standard | null | undefined;
    setTrees: Array<Standard>;
    domain: string;
};

const StandardsMappingContent = (props: Props): React.ReactElement => {
    const {subTreeToShow, setTrees, domain} = props;

    const standards = subTreeToShow?.standards ?? setTrees[0]?.standards ?? [];
    const firstStandard = standards[0] ?? null;
    const firstURL = firstStandard
        ? `/standards/${firstStandard.setId}/${firstStandard.standardId}`
        : "";

    const bodyText =
        domain === "math"
            ? doNotTranslateYet`Looking for Math content that aligns with your state standards? Select your grade or subject matter to find Khan Academy math exercises and videos from our library of free content.`
            : doNotTranslateYet`Looking for content that aligns with your state standards? Select your grade or subject matter to find Khan Academy exercises and videos from our library of free content.`;

    return (
        <View style={styles.marginSmall}>
            {subTreeToShow && (
                <Title tag="h3" style={styles.highLevelTitle}>
                    {subTreeToShow.description}
                </Title>
            )}
            <Body style={styles.topLevelBody}>{bodyText}</Body>
            {firstURL && (
                <View style={styles.buttonContainer}>
                    <Button kind="primary" href={firstURL}>
                        {doNotTranslateYet`Get Started`}
                    </Button>
                </View>
            )}
        </View>
    );
};

const styles = {
    marginSmall: {
        margin: spacing.small_12,
    },

    highLevelTitle: {
        paddingBottom: spacing.medium_16,
    },

    topLevelBody: {
        lineHeight: "22px",
        paddingBottom: spacing.medium_16,
    },

    buttonContainer: {
        flexDirection: "row",
    },
} as const;

export default StandardsMappingContent;
